module.exports = __webpack_public_path__ + "public/images/curated-below-the-fold-frame.427a696ed858bc3abd7800ab0b4ab72c.png";